import {Button, Col, Modal, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import DateBox from "../../../../primer/DateBox";
import moment from "moment/moment";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import HourPicker from "../../../../primer/HourPicker";
import {toast} from "react-toastify";
import axios from "axios";

const AcsEmailModal = ({show, setShow}) => {


    const [buttonLoader, setButtonLoader] = useState(false);
    const [date, setDate] = useState(new Date());
    const [time, setTime] = useState(moment().add(3, "hours"));

    useEffect(() => {
        if(show) {
            const targetTime = moment().set({ hour: 18, minute: 15, second: 0, millisecond: 0 });
            if(moment().add(3, "hours").isAfter(targetTime)) {
                setDate(moment().add(1, "day").toDate());
                setTime(moment().add(27, "hours"));
            } else {
                setDate(moment().toDate());
                setTime(moment().add(3, "hours"));
            }
        }
    }, [show]);

    const sendAcsEmailNotification = () => {
        if(isEmpty(date) || isEmpty(time)) return toast.error("Παρακαλώ επιλέξτε ημερομηνία και ώρα!");
        const selectedDateTime = moment(date).set({hour: moment(time).get('hour'), minute: moment(time).get('minute'), second: 0, millisecond: 0});
        const now = moment();
        const diffInHours = selectedDateTime.diff(now, 'hours', true);
        if (diffInHours < 3) {
            return toast.error("Η ημερομηνία και ώρα παραλαβής πρέπει να είναι τουλάχιστον 3 ώρες μετά από την τωρινή ώρα.");
        }
        setButtonLoader(true);
        axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-send-acs-email", {pickUpDate: selectedDateTime}, {headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if(res.data.status === "200") {
                setShow(false);
                toast.success(res.data.message);
            } else {
                toast.error(res.data.message);
            }
            setButtonLoader(false);
        }).catch((error) => {
            toast.error(error);
            console.log(error);
            setButtonLoader(false);
        })
    }

    return (
        <Modal backdrop={"static"} show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton style={{textAlign: 'center'}}>
                <Modal.Title>Αποστολή Email στην ACS για Παραλαβή</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <div></div>
               Επιλέξτε ημερομηνία και ώρα παραλαβής που επιθυμείτε για την παραλαβή των δεμάτων σας από την ACS.
                <br />
                ΠΡΟΣΟΧΉ! Η ημερομηνία και ώρα πρέπει να είναι τουλάχιστον 3 ώρες μετά από την τωρινή ώρα.
                <br />
                Η τελευταία δυνατή ώρα παραλαβής είναι 18:15!
                <br />
                Η αποστολή email θα γίνει με αποστολέα το email "shipping@primer.gr" με την χρήση IMAP πρωτοκόλλου με αποτέλεσμα να αποθηκευτεί στο φάκελο των απεσταλμένων
                email. Παρακαλώ πολύ παρακολουθήστε το παραπάνω email σε περίπτωση απάντησης από την ACS.
                <hr />
                <Row>
                    <Col md={6}>
                        <DateBox
                            label={"Ημερομηνία Παραλαβής"}
                            name="shippingDate"
                            required={true}
                            disabled={buttonLoader}
                            minDate={moment().toDate()}
                            selected={(moment(date).isValid() && !isEmpty(date)) ? moment(date).toDate() : new Date()}
                            onChange={(e) => setDate(e ? moment(e).toDate() : "")}
                        />
                    </Col>
                    <Col md={6}>
                        <HourPicker
                            label={"Ώρα Παραλαβής"}
                            disabled={buttonLoader}
                            required={true}
                            selected={moment(time, "HH:mm").toDate()}
                            onChange={(e) => setTime(moment(e, "HH:mm").toDate())}
                        />
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={buttonLoader} variant="primary" onClick={() => sendAcsEmailNotification()}>
                    {"Αποστολή Ειδοποίησης "}
                    {buttonLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AcsEmailModal;